export default "__VITE_ASSET__CElSbWQG__"